
<div class="component-container">


<div class="container">
    <header>
        <h1>Account Settings</h1>
    </header>

    <div class="settings-layout">
        <div class="settings-sidebar">
            <ul class="nav-tabs">
                <!--
                <li><a href="#profile" [class.active]="activeSection === 'profile'" (click)="selectSection($event, 'profile')" data-section="profile"><span class="icon">👤</span> Profile</a></li>
                -->
                <li><a [class.active]="activeSection === 'account'"  (click)="selectSection($event, 'account')" data-section="account"><span class="icon">🔐</span> Account</a></li>
                <li><a [class.active]="activeSection === 'billing'"  (click)="selectSection($event, 'billing')" data-section="billing"><span class="icon">💳</span> Billing</a></li>
                <!--
                <li><a href="#notifications" [class.active]="activeSection === 'notifications'" (click)="selectSection($event, 'notifications')" data-section="notifications"><span class="icon">🔔</span> Notifications</a></li>
                
                <li><a href="#privacy" [class.active]="activeSection === 'privacy'" (click)="selectSection($event, 'privacy')" data-section="privacy"><span class="icon">🔒</span> Privacy</a></li>
                -->
            </ul>
        </div>

        <div class="settings-content">
            <!-- Profile Sectio -->
            <div [id]="'general'" [class.section-hidden]="activeSection !== 'profile'" class="settings-section">
                <h2>Profile Information</h2>

                <!--
                <div class="avatar-section">
                    <div class="avatar">
                        <img src="https://i.pravatar.cc/200" alt="Profile avatar">
                    </div>
                    <div class="avatar-buttons">
                        <button class="btn btn-secondary">Upload New Photo</button>
                        <button class="btn btn-secondary">Remove Photo</button>
                    </div>
                </div>
                -->
                
                <form id="profileForm">

                    <!--
                    <div class="input-group">
                        <div class="form-group">
                            <label for="firstName">First Name</label>
                            <input type="text" id="firstName" value="John" required>
                        </div>
                        <div class="form-group">
                            <label for="lastName">Last Name</label>
                            <input type="text" id="lastName" value="Doe" required>
                        </div>
                    </div>
                    -->
                    
                    <div class="form-group">
                        <label for="displayName">Display Name</label>
                        <input type="text" name="displayName" [(ngModel)]="userInfo.username" required minlength="2">
                    </div>
                    <!--
                    
                    <div class="form-group">
                        <label for="bio">Bio</label>
                        <textarea id="bio" rows="4" placeholder="Tell us about yourself">Software developer with a passion for UI/UX design and web technologies.</textarea>
                    </div>
                    
                    <div class="form-group">
                        <label for="location">Location</label>
                        <input type="text" id="location" value="San Francisco, CA">
                    </div>
                    
                    <div class="form-group">
                        <label for="website">Website</label>
                        <input type="url" id="website" value="https://johndoe.com">
                    </div>
                    -->
                    
                    <div class="button-group">
                        <button type="button" class="btn btn-secondary">Cancel</button>
                        <button type="submit" class="btn btn-primary">Save Changes</button>
                    </div>
                </form>
            </div>
            

            <!-- Account Section -->
            <div [id]="'account'" [class.section-hidden]="activeSection !== 'account'" class="settings-section">
                <h2>Account Settings</h2>
                
                <div class="success-message" id="accountSuccessMessage" [style.display]="accountUpdated ? 'block' : 'none'">
                    Your account settings have been updated successfully!
                </div>
                
                <div id="accountForm">
                    <div class="form-group">
                        <label for="email">Email Address</label>
                        <input type="email" name="email" [(ngModel)]="userInfo.email" required readonly>
                        <div class="error-message" id="emailError"></div>
                    </div>

                    <div class="button-group">
                        <button type="button" class="btn btn-primary" [routerLink]="['/update-email']">Update Email</button>
                    </div>
                    
                    <div class="form-group">
                        <label for="username">Username</label>
                        <input type="text" name="username" #userName="ngModel" [(ngModel)]="userInfo.username" required minlength="2" >
                        <div class="error-message" id="usernameError"></div>
                    </div>
                    
                    <!--
                    <h3 style="margin: 2rem 0 1rem; color: #ffffff;">Change Password</h3>
                    
                    <div class="form-group">
                        <label for="currentPassword">Current Password</label>
                        <div class="password-container">
                            <input type="password" id="currentPassword" placeholder="Enter current password">
                            <button type="button" class="toggle-password" aria-label="Toggle password visibility">Show</button>
                        </div>
                        <div class="error-message" id="currentPasswordError"></div>
                    </div>
                    
                    <div class="form-group">
                        <label for="newPassword">New Password</label>
                        <div class="password-container">
                            <input type="password" id="newPassword" placeholder="Enter new password">
                            <button type="button" class="toggle-password" aria-label="Toggle password visibility">Show</button>
                        </div>
                        <div class="error-message" id="newPasswordError"></div>
                    </div>
                    
                    <div class="form-group">
                        <label for="confirmPassword">Confirm New Password</label>
                        <div class="password-container">
                            <input type="password" id="confirmPassword" placeholder="Confirm new password">
                            <button type="button" class="toggle-password" aria-label="Toggle password visibility">Show</button>
                        </div>
                        <div class="error-message" id="confirmPasswordError"></div>
                    </div>
                    -->
                    
                    <div class="button-group">
                        <button type="button" class="btn btn-primary" (click)="updateUsername()" [disabled]="userName.invalid">Save Username</button>
                    </div>
                    
                    <hr style="margin: 2rem 0; border: none; border-top: 1px solid #333;">
                    
                    <h3 style="margin-bottom: 1rem; color: #ffffff;">Danger Zone</h3>
                    <p style="margin-bottom: 1rem; color: #b0b0b0;">Once you delete your account, there is no going back. Please be certain.</p>
                    <button type="button" class="btn btn-danger" (click)="requestAccountDeletion()">Delete Account</button>
                </div>
            </div>

            <!-- Billing Section -->
            <div [id]="'billing'" [class.section-hidden]="activeSection !== 'billing'" class="settings-section">
                <h2>Billing Information</h2>

                <div class="subscription-info" *ngIf="activeSubs.length === 0">
                    <h3>Current Plan</h3>
                    <div class="subscription-details">
                        <p>Plan</p>
                        <p>None <span class="badge badge-error">None</span></p>
                    </div>

                    <div class="button-group">
                        <button type="button" class="btn btn-secondary" [routerLink]="['/cart-view']">Add Subscription</button>
                    </div>
                </div>
                
                <div class="subscription-info" *ngFor="let sub of activeSubs">
                    <h3>Current Plan</h3>
                    <div class="subscription-details">
                        <p>Plan</p>
                        <p>{{ sub.name }} </p>
                    </div>

                    <div class="subscription-details">
                        <p>Type</p>
                        <p>{{ sub.type }}</p>
                    </div>
                    <div class="subscription-details">
                        <p>Billing Period</p>
                        <p><span class="badge" [ngClass]="{ 'badge-success': sub.status === 'active', 'badge-error': sub.status !== 'active' }">{{ sub.interval }}</span></p>
                    </div>
                    <div class="subscription-details">
                        <p>Amount</p>
                        <p>{{ ( sub.amount / 100 ) | currency }}</p>
                    </div>
                    
                    <div class="button-group">
                        <button type="button" class="btn btn-secondary" (click)="openCustomerPortal()">Manage Subscription</button>
                    </div>
                </div>
                
                <h3 style="margin: 2rem 0 1rem; color: #ffffff;">Payment</h3>
                <!--
                <div class="card-list">
                    <div class="payment-card">
                        <div class="card-info">
                            <div class="card-icon">
                                VISA
                            </div>
                            <div class="card-details">
                                <h4>Visa ending in 4242</h4>
                                <p>Expires 12/2025</p>
                            </div>
                        </div>
                        <div class="card-actions">
                            <button>Set as Default</button>
                            <button>Edit</button>
                            <button>Remove</button>
                        </div>
                    </div>
                    
                    <div class="payment-card">
                        <div class="card-info">
                            <div class="card-icon">
                                MC
                            </div>
                            <div class="card-details">
                                <h4>Mastercard ending in 5555</h4>
                                <p>Expires 08/2024</p>
                            </div>
                        </div>
                        <div class="card-actions">
                            <button>Set as Default</button>
                            <button>Edit</button>
                            <button>Remove</button>
                        </div>
                    </div>
                </div>
                -->
                
                <button type="button" class="btn btn-secondary" (click)="openCustomerPortal()">Manage Payment</button>
                
                
                <!--
                <h3 style="margin: 2rem 0 1rem; color: #ffffff;">Billing Address</h3>
                <form id="billingAddressForm">
                    <div class="form-group">
                        <label for="billingName">Full Name</label>
                        <input type="text" id="billingName" value="John Doe" required>
                    </div>
                    
                    <div class="form-group">
                        <label for="billingAddress">Address</label>
                        <input type="text" id="billingAddress" value="123 Main St" required>
                    </div>
                    
                    <div class="input-group">
                        <div class="form-group">
                            <label for="billingCity">City</label>
                            <input type="text" id="billingCity" value="San Francisco" required>
                        </div>
                        <div class="form-group">
                            <label for="billingState">State</label>
                            <input type="text" id="billingState" value="CA" required>
                        </div>
                        <div class="form-group">
                            <label for="billingZip">ZIP Code</label>
                            <input type="text" id="billingZip" value="94105" required>
                        </div>
                    </div>
                    
                    <div class="form-group">
                        <label for="billingCountry">Country</label>
                        <select id="billingCountry" required>
                            <option value="US" selected>United States</option>
                            <option value="CA">Canada</option>
                            <option value="UK">United Kingdom</option>
                            <option value="AU">Australia</option>
                        </select>
                    </div>
                    
                    <div class="button-group">
                        <button type="button" class="btn btn-secondary">Cancel</button>
                        <button type="submit" class="btn btn-primary">Save Changes</button>
                    </div>
                </form>
                -->
            </div>

            <!-- Notifications Section 
            <div [id]="'notifications'" [class.section-hidden]="activeSection !== 'notifications'" class="settings-section">
                <h2>Notification Preferences</h2>
                
                <div class="toggle-option">
                    <div class="toggle-option-text">
                        <h4>Email Notifications</h4>
                        <p>Receive email notifications for account activity and updates</p>
                    </div>
                    <label class="toggle-switch">
                        <input type="checkbox" checked>
                        <span class="toggle-slider"></span>
                    </label>
                </div>
                
                <div class="toggle-option">
                    <div class="toggle-option-text">
                        <h4>Product Updates</h4>
                        <p>Receive emails about new features and improvements</p>
                    </div>
                    <label class="toggle-switch">
                        <input type="checkbox" checked>
                        <span class="toggle-slider"></span>
                    </label>
                </div>
                
                <div class="toggle-option">
                    <div class="toggle-option-text">
                        <h4>Security Alerts</h4>
                        <p>Get notified about important security updates</p>
                    </div>
                    <label class="toggle-switch">
                        <input type="checkbox" checked>
                        <span class="toggle-slider"></span>
                    </label>
                </div>
                
                <div class="toggle-option">
                    <div class="toggle-option-text">
                        <h4>Marketing Emails</h4>
                        <p>Receive promotional offers and marketing communications</p>
                    </div>
                    <label class="toggle-switch">
                        <input type="checkbox">
                        <span class="toggle-slider"></span>
                    </label>
                </div>
                
                <div class="toggle-option">
                    <div class="toggle-option-text">
                        <h4>Newsletter</h4>
                        <p>Receive our weekly newsletter with tips and tricks</p>
                    </div>
                    <label class="toggle-switch">
                        <input type="checkbox" checked>
                        <span class="toggle-slider"></span>
                    </label>
                </div>
                
                <div class="button-group">
                    <button type="button" class="btn btn-secondary">Reset to Default</button>
                    <button type="button" class="btn btn-primary">Save Preferences</button>
                </div>
            </div>
            -->


            <!-- Privacy Section
            <div [id]="'privacy'" [class.section-hidden]="activeSection !== 'privacy'" class="settings-section">
                <h2>Privacy & Security</h2>
                
                <div class="toggle-option">
                    <div class="toggle-option-text">
                        <h4>Two-Factor Authentication</h4>
                        <p>Add an extra layer of security to your account</p>
                    </div>
                    <label class="toggle-switch">
                        <input type="checkbox">
                        <span class="toggle-slider"></span>
                    </label>
                </div>
                
                <div class="toggle-option">
                    <div class="toggle-option-text">
                        <h4>Profile Visibility</h4>
                        <p>Make your profile visible to other users</p>
                    </div>
                    <label class="toggle-switch">
                        <input type="checkbox" checked>
                        <span class="toggle-slider"></span>
                    </label>
                </div>
                
                <div class="toggle-option">
                    <div class="toggle-option-text">
                        <h4>Data Sharing</h4>
                        <p>Allow us to use your data to improve our services</p>
                    </div>
                    <label class="toggle-switch">
                        <input type="checkbox" checked>
                        <span class="toggle-slider"></span>
                    </label>
                </div>
                
                <div class="toggle-option">
                    <div class="toggle-option-text">
                        <h4>Activity Tracking</h4>
                        <p>Allow us to track your activity for personalized recommendations</p>
                    </div>
                    <label class="toggle-switch">
                        <input type="checkbox" checked>
                        <span class="toggle-slider"></span>
                    </label>
                </div>
                
                <h3 style="margin: 2rem 0 1rem; color: #ffffff;">Login Sessions</h3>
                
                <div class="card-list">
                    <div class="payment-card">
                        <div class="card-info">
                            <div class="card-icon" style="background-color: #7c4dff;">
                                <span style="font-size: 0.8rem;">NOW</span>
                            </div>
                            <div class="card-details">
                                <h4>Current Session</h4>
                                <p>Chrome on macOS • San Francisco, CA • IP: 192.168.1.1</p>
                            </div>
                        </div>
                    </div>
                    
                    <div class="payment-card">
                        <div class="card-info">
                            <div class="card-icon" style="background-color: #444;">
                                <span style="font-size: 0.8rem;">2d</span>
                            </div>
                            <div class="card-details">
                                <h4>Safari on iOS</h4>
                                <p>San Francisco, CA • IP: 192.168.1.2 • May 12, 2023</p>
                            </div>
                        </div>
                        <div class="card-actions">
                            <button>Revoke</button>
                        </div>
                    </div>
                    
                    <div class="payment-card">
                        <div class="card-info">
                            <div class="card-icon" style="background-color: #444;">
                                <span style="font-size: 0.8rem;">5d</span>
                            </div>
                            <div class="card-details">
                                <h4>Firefox on Windows</h4>
                                <p>New York, NY • IP: 192.168.1.3 • May 9, 2023</p>
                            </div>
                        </div>
                        <div class="card-actions">
                            <button>Revoke</button>
                        </div>
                    </div>
                </div>
                
                <button type="button" class="btn btn-danger">Revoke All Sessions</button>
                
                <h3 style="margin: 2rem 0 1rem; color: #ffffff;">Data & Privacy</h3>
                
                <p style="margin-bottom: 1.5rem; color: #b0b0b0;">You can request a copy of your data or delete your account and all associated data.</p>
                
                <div class="button-group">
                    <button type="button" class="btn btn-secondary">Download My Data</button>
                    <button type="button" class="btn btn-danger">Delete My Account</button>
                </div>
            </div>
            -->
        </div>
    </div>
</div>
</div>